var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQueueNotAppear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.27L9.05478 12.0275L10.6295 13.8913L12.2043 12.0275L13.2591 13.27L11.6769 15.125L13.2591 16.98L12.2043 18.2225L10.6295 16.3587L9.05478 18.2225L8 16.98L9.58217 15.125L8 13.27ZM18.0576 16.875C20.0409 16.875 24 18.0387 24 20.375V23H12.1151V20.375C12.1151 18.0387 16.0743 16.875 18.0576 16.875ZM18.0576 18.5375C15.8292 18.5375 13.5265 19.815 13.5265 20.375V21.3375H22.5887V20.375C22.5887 19.815 20.2637 18.5375 18.0576 18.5375Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3684 9C16.5158 9 15 10.5158 15 12.3684C15 14.2211 16.5158 15.7368 18.3684 15.7368C20.2211 15.7368 21.7368 14.2211 21.7368 12.3684C21.7368 10.5158 20.2211 9 18.3684 9ZM18.3684 10.6842C19.2947 10.6842 20.0526 11.4421 20.0526 12.3684C20.0526 13.2947 19.2947 14.0526 18.3684 14.0526C17.4421 14.0526 16.6842 13.2947 16.6842 12.3684C16.6842 11.4421 17.4421 10.6842 18.3684 10.6842Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueueNotAppear);
export default __webpack_public_path__ + "static/media/queue_notAppear.cab04469228630443b54c4e33133f633.svg";
export { ForwardRef as ReactComponent };